export const calcDV = (rut: string | number): string =>
  String(
    11 -
      (String(rut)
        .split("")
        .reverse()
        .reduce((acc, curr, idx) => acc + Number(curr) * ((idx % 6) + 2), 0) %
        11)
  )
    .replace(/10/, "k")
    .replace(/11/, "0");

export const getSegmentedRut = (rut: string | number): { rut: string; dv: string } => {
  const [baseRut, dv] = rut.toString().split("-");

  return {
    rut: baseRut.replace(/\./g, ""),
    dv: dv ?? calcDV(rut),
  };
};
